
























































import { PropType } from 'vue';

import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import { IContract } from '@/models';

import ContractPhaseDisplay from './ContractPhaseDisplay.vue';
import ContractAttachmentsList from './ContractAttachmentsList.vue';

export default mixins(auth, snackbar).extend({
  name: 'ContractDetailDrawer',

  components: {
    ContractPhaseDisplay,
    ContractAttachmentsList
  },

  props: {
    contract: {
      type: Object as PropType<IContract>
    }
  },

  data() {
    return {
      isDrawerMini: true
    };
  }
});
